import { render, staticRenderFns } from "./HistorialTurnos.vue?vue&type=template&id=05093ac4"
import script from "./HistorialTurnos.vue?vue&type=script&lang=js"
export * from "./HistorialTurnos.vue?vue&type=script&lang=js"
import style0 from "./HistorialTurnos.vue?vue&type=style&index=0&id=05093ac4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports